module.exports = __webpack_public_path__ + "media/img/payments/header-mobile-0d1bd1b8722839d0f532b6b689ece337.svg";